import React, { useState } from 'react';
import { Modal, Typography, Box, Backdrop, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import usePartyDetails from '../Components/usePartyDetails';
import { useStateList } from '../Components/HandleInvoiceStateProvider';
import { useSelector } from 'react-redux';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  outline: 'none',
  borderRadius: '4px',
};

const PageResetModal = ({ open, setOpen, newChangeValue, onChange, newPartyID, setNewPartyID, setNewChangeValue }) => {
  const {
    setData,

    setTotTaxAmt,

    setTotDicount,

    setTotGSTCess,

    setTotNetAmt,

    setTotGST,

    setInvTransArr,

    setPaymentTransArr,

    partyType,

    setItems,
    items,
    nonItems,
    setDeletedItems,
    setDeletedNonItems,
    initItemTableDta,
    initNonItemTableData,

    setNonItems,
  } = useStateList();

  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  let companyType = getCompany?.relatedcompanydetailsnew?.[0].registrationtype;
  let today = new Date();
  let yy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;

  const todayDate = yy + '-' + mm + '-' + dd;
  const [loading, setLoading] = useState(false);
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
      setNewPartyID('');
      setNewChangeValue({ label: '', value: '' });
    }
  };

  const { paryDetails } = usePartyDetails({
    Id: newPartyID || newChangeValue?.value,
  });

  const newItemObj = {
    itemCode: { label: '', value: '' },
    name: { label: '', value: '' },
    priceType: { label: '', value: '' },
    ledgerAccount: { label: '', value: '' },
    HSN: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    qty: 0,
    units: '',
    rate: 0,
    amount: 0,
    dicount: 0,
    taxableAMount: 0,
     GSTRate: '',manualGSTFlag:0,
    taxability: { label: '', value: '' },
    manualDiscount: false,
    manualCess: false,
    IGST: 0,
    CGST: '0.00',
    SGST: '0.00',
    GSTCess: 0,
    netAmount: '0000',
    editable: true,
    new: true,
  };
  const newNonItemObj = {
    ledgerAccount: { label: '', value: '' },
    HSN: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    description: '',
    taxableAMount: 0,
     GSTRate: '',manualGSTFlag:0,
    taxability: { label: '', value: '' },
    taxType:0,
    manualDiscount: false,
    manualCess: false,
    IGST: 0,
    CGST: '0.00',
    SGST: '0.00',
    GSTCess: 0,
    netAmount: 0,
    editable: true,
    new: true,
  };

  function handlePartyPlaceOfSupply() {
    setItems([]);
    setTotNetAmt(0);
    setTotGST(0);
    setTotGSTCess(0);
    setTotTaxAmt(0);
    setTotDicount(0);
    setNonItems([]);
    setInvTransArr([]);
    setPaymentTransArr([]);
    setData((prev) => ({
      ...prev,
      orderNumber: '',
      // entryDate: todayDate,
      // invoiceDate: todayDate,
      // customerOrderDate: todayDate,
      supplier: '',
      paymentType: 'Credit',
      receivedAmount: '',
      receivedAccount: { label: '', value: '' },
      taxability: { label: '', value: '' },
      creditPeriod: '',
      bankReferenceNo: '',
      // dueDate: todayDate,
      tdsFlag: '',
      tdsOptions: '',
      tdsAmount: '',
      adjustments: '',
      ineligibleITCFlag: '',
      reverseChargeFlag: 0,
      remarks: '',
      address: '',
      billingAddress: '',
      deliveryAddress: '',
      // gstin: "",
      transportMode: '',
      vehicleNumber: '',
      dateOfDispatch: todayDate,
      gstCategory: '',
      ewayBillNo: '',
      CancelFlag: 0,
      tcsFlag: 0,
      tcsOptions: '',
      tdsPercent: '',
      tcsPercent: '',
      tcsAmount: 0,
      // consigneeName: "",
      // consigneeGST: "",
      roundOff: 0,
      adjustmentsType: '1',
      originalInvoiceNumber: {
        label: '',
        value: '',
        regType: '',
        taxability: '',
        invDate: '',
      },
      partyInvNo:'',
      adjustmentsValue: 0,
      balanceDueAmt: 0,
      ITCFlag:0,
      errorStatus: {
        orderNumber: false,
        entryDate: false,
        invoiceDate: false,
        customerOrderDate: false,
        voucherNumber: false,
        partyName: false,
        paymentType: false,
        receivedAmount: false,
        receivedAccount: false,
        creditPeriod: false,
        bankReferenceNo: false,
        dueDate: false,
        tdsFlag: false,
        tdsOptions: false,
        tdsAmount: false,
        tcsFlag: false,
        tcsOptions: false,
        tcsAmount: false,
        adjustments: false,
        ineligibleITCFlag: false,
        reverseChargeFlag: false,
        remarks: false,
        placeOfSupply: false,
        address: false,
        gstin: false,
        transportMode: false,
        vehicleNumber: false,
        dateOfDispatch: false,
        ewayBillNo: false,
        transactionVoucher: false,
        seriesVouchers: false,
        transactionSeries: false,
        consigneeName: false,
        consigneeGST: false,
        roundOff: false,
        tdsPercent: false,
        tcsPercent: false,
        adjustmentsType: false,
        adjustmentsValue: false,
        balanceDueAmt: false,
        originalInvoiceNumber: false,
        taxability: false,
      },
      errorFields: {
        orderNumber: '',
        entryDate: '',
        invoiceDate: '',
        customerOrderDate: '',
        voucherNumber: '',
        partyName: '',
        paymentType: '',
        receivedAmount: '',
        receivedAccount: '',
        creditPeriod: '',
        bankReferenceNo: '',
        dueDate: '',
        tcsFlag: '',
        tcsOptions: '',
        tcsAmount: '',
        tdsFlag: '',
        tdsOptions: '',
        tdsAmount: '',
        adjustments: '',
        ineligibleITCFlag: '',
        reverseChargeFlag: '',
        remarks: '',
        placeOfSupply: '',
        address: '',
        gstin: '',
        transportMode: '',
        vehicleNumber: '',
        dateOfDispatch: '',
        ewayBillNo: '',
        transactionVoucher: '',
        seriesVouchers: '',
        transactionSeries: '',
        consigneeName: '',
        consigneeGST: '',
        tdsPercent: '',
        tcsPercent: '',
        roundOff: '',
        adjustmentsType: '',
        adjustmentsValue: '',
        balanceDueAmt: '',
        originalInvoiceNumber: '',
        taxability: '',
      },
    }));
    Math.floor(new Date().getTime() / 1000);
    const exp = Math.floor(new Date().getTime() / 1000);
    const filteredItemTableData = initItemTableDta.filter((item) => item.id != null).map((item) => ({ ...item, expiredtimestamp: exp }));

    const filteredNonItemTableData = initNonItemTableData
      .filter((item) => item.id != null)
      .map((item) => ({ ...item, expiredtimestamp: exp }));
    setDeletedItems(filteredItemTableData);
    setDeletedNonItems(filteredNonItemTableData);
    setItems([newItemObj]);
    setNonItems([newNonItemObj]);

    // onChange(newChangeValue?.type === 'party' || newPartyID ? paryDetails : newChangeValue)
    onChange(newChangeValue?.type === 'party'? paryDetails : newChangeValue); // fixed for place of supply [Object Object]
    setNewChangeValue({ label: '', value: '' });
    setNewPartyID('');

    setOpen(false);
  }
  async function reset() {
    handlePartyPlaceOfSupply();
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Box sx={style}>
        <Box
          sx={{
            borderRadius: '4px',
            backgroundColor: 'white',
            padding: '15px',
            textAlign: 'center',
            overflowY: { xs: 'scroll', sm: 'hidden' },
            '.MuiTableCell-root': {
              padding: '10px 10px',
              fontSize: '13px',
            },
          }}
        >
          <Typography sx={{ color: 'rgb(60 60 60)', fontWeight: 'bold' }}>
            {newChangeValue?.type === 'party'
              ? partyType === 'CUSTOMER'
                ? 'Do you want to change the customer?'
                : 'Do you want to change the supplier?'
              : 'Do you want to change the place of supply?'}
          </Typography>
          <span style={{ color: 'red', fontSize: '12px' }}>
            *{' '}
            {newChangeValue?.type === 'party'
              ? companyType == 3
                ? 'Changing the party will reset all entries.'
                : 'Changing the party will reset all entries because taxability  will be updated.'
              : companyType == 3
              ? 'Changing the party will reset all entries.'
              : 'Changing the place of supply will reset all entries because taxability  will be updated.'}
          </span>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', sm: 'row' },
            paddingLeft: '15px',
            paddingRight: '15px',
            paddingBottom: '15px',
          }}
        >
          <Button disabled={loading} onClick={handleClose} variant="outlined" sx={{ flex: 1, margin: '5px', fontSize: '12px' }}>
            No
          </Button>
          {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
          <LoadingButton
            color="error"
            sx={{ flex: 1, margin: '5px', fontSize: '12px' }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={() => reset()}
          >
            Yes
          </LoadingButton>
        </Box>
      </Box>
      {/* </Fade> */}
    </Modal>
  );
};

export default PageResetModal;
